import { CompetentionsLevels } from './CompetentionsLevels';

export default CompetentionsLevels;